import { computed as n, toValue as t } from "vue";
import { tw as e } from "../utils/tailwind.js";
function u(a, d) {
  return { overlayClassNames: n(() => {
    const o = t(a), r = t(d);
    return [
      e`rounded-sm pointer-events-none absolute inset-0`,
      e`ease-in motion-safe:transition-colors motion-safe:duration-200`,
      !r && o && e`border-retina border-action-default-low-pressed`,
      !r && !o && e`border border-action-default-low`,
      r && o && e`border-retina border-action-default-low-disabled`,
      r && !o && e`border border-action-default-low-disabled`
    ];
  }) };
}
export {
  u as useSelectionCardBorder
};
